import PhatDropdown from 'components/formElements/PhatDropdown'

type Props = {
  value?: boolean
  onChange: (value: boolean) => void
  disabled?: boolean
}

const AllPrintingsDropdown = ({ value = false, onChange, disabled }: Props) => (
  <PhatDropdown
    inlineHeader
    header="Printings:"
    disabled={disabled}
    options={[
      { label: 'Single Printing', onClick: () => onChange(false), id: 'false' },
      { label: 'All Printings', onClick: () => onChange(true), id: 'true' },
    ]}
    value={`${value}`}
  />
)

export default AllPrintingsDropdown
